module.exports = __webpack_public_path__ + "img/Joint.101b03b9.jpg";